const initMap = (() => {
	mapboxgl.accessToken =
		'pk.eyJ1IjoieWFyZCIsImEiOiJabnJ4VktBIn0.Z5wYmX0h8NsXdPND9deofQ'
	const location = [-6.412659898199053, 53.518354590397166]
	const map = new mapboxgl.Map({
		container: 'map',
		style: 'mapbox://styles/mapbox/streets-v12',
		center: location,
		zoom: 15,
	})

	const popupContent =
		"<p id='map-popup-content'>Click to navigate: <a href='https://goo.gl/maps/Hv6XortPsKmiXVS8A'>SEAMLESS GROUP</a><p>"
	const marker = new mapboxgl.Marker()
		.setLngLat(location)
		.setPopup(new mapboxgl.Popup().setHTML(popupContent))
		.addTo(map)
})()
